import { Action } from '@ngrx/store';
import {
  Account,
  ObjectCounts,
  Fund,
  Manager,
  LogsResponse,
  Client,
  OverviewItem,
  LoadClientsResponse,
  UploadFileRequest, LoadFileResponse
} from './administration.models';
import { LoadUsersResponse, User } from './user/user.models';
import { ClientManagers } from './consultant/consultant.models';
import {
  LoadDataRequest, SortInfo, LoadRequest, FilterInfo,
  DatesIntervalRequest, DatesInterval, StaticData,
  LoadDataRequestAtlas
} from '../../global/interfaces';

import { Document, LoadDocumentsResponse } from './document/document.models';
import { StaticDataPayload } from '../../shared/layout/main.models';
import { PaginationInfo } from 'atlas-pagination';

export enum ActionTypes {
  LOAD_ACCOUNTS = '[Administration] Load Accounts Action',
  LOAD_ACCOUNTS_SUCCESS = '[Administration] Load Accounts Success Action',
  LOAD_ACCOUNTS_FAILED = '[Administration] Load Accounts Failed Action',

  LOAD_FUNDS = '[Administration] Load Funds Action',
  LOAD_FUNDS_SUCCESS = '[Administration] Load Funds Success Action',
  LOAD_FUNDS_FAILED = '[Administration] Load Funds Failed Action',

  LOAD_COUNTS = '[Administration] Load Item Counts Action',
  LOAD_COUNTS_SUCCESS = '[Administration] Load Item Counts Success Action',
  LOAD_COUNTS_FAILED = '[Administration] Load Item Counts Failed Action',

  LOAD_CLIENTS = '[Administration Client] Load Clients Action',
  LOAD_CLIENTS_SUCCESS = '[Administration Client] Load Clients Success Action',
  LOAD_CLIENTS_FAILED = '[Administration Client] Load Clients Failed Action',

  CREATE_CLIENT = '[Administration Client] Create Client Action',
  CREATE_CLIENT_SUCCESS = '[Administration Client] Create Client Success Action',
  CREATE_CLIENT_FAILED = '[Administration Client] Create Client Failed Action',

  UPDATE_CLIENT = '[Administration Client] Update Client Action',
  UPDATE_CLIENT_SUCCESS = '[Administration Client] Update Client Success Action',
  UPDATE_CLIENT_FAILED = '[Administration Client] Update Client Failed Action',

  SET_CLIENT_SORT = '[Administration Client] Set Client Sort Action',
  SET_CLIENT_PAGINATION = '[Administration Client] Set Client Pagination Action',
  SET_CLIENT_FILTER = '[Administration Client] Set Client Filter Action',

  CLIENT_PDF_EXPORT = '[Administration Client] Client File Export Action',

  LOAD_USERS = '[Administration User] Load Users Action',
  LOAD_USERS_SUCCESS = '[Administration User] Load Users Success Action',
  LOAD_USERS_FAILED = '[Administration User] Load Users Failed Action',

  LOAD_USER_CLIENTS = '[Administration User] Load User Clients Action',
  LOAD_USER_CLIENTS_SUCCESS = '[Administration User] Load User Clients Success Action',
  LOAD_USER_CLIENTS_FAILED = '[Administration User] Load User Clients Failed Action',

  CREATE_USER = '[Administration User] Create User Action',
  CREATE_USER_SUCCESS = '[Administration User] Create User Success Action',
  CREATE_USER_FAILED = '[Administration User] Create User Failed Action',

  UPDATE_USER = '[Administration User] Update User Action',
  UPDATE_USER_SUCCESS = '[Administration User] Update User Success Action',
  UPDATE_USER_FAILED = '[Administration User] Update User Failed Action',

  SET_USER_SORT = '[Administration User] Set User Sort Action',
  SET_USER_PAGINATION = '[Administration User] Set User Pagination Action',
  SET_USER_FILTER = '[Administration User] Set User Filter Action',

  USER_PDF_EXPORT = '[Administration User] User File Export Action',

  UPLOAD_PROFILE_IMAGE = '[Administration User] Upload User Profile Action',
  UPLOAD_PROFILE_IMAGE_SUCCESS = '[Administration User] Upload User Profile Success Action',
  UPLOAD_PROFILE_IMAGE_FAILED = '[Administration User] Upload User Profile Failed Action',

  UPLOAD_CLIENT_LOGO = '[Administration Client] Upload Client Logo Action',
  UPLOAD_CLIENT_LOGO_SUCCESS = '[Administration Client] Upload Client Logo Success Action',
  UPLOAD_CLIENT_LOGO_FAILED = '[Administration Client] Upload Client Logo Failed Action',

  LOAD_CONSULTANTS = '[Administration Consultant] Load Consultants Action',
  LOAD_CONSULTANTS_SUCCESS = '[Administration Consultant] Load Consultants Success Action',
  LOAD_CONSULTANTS_FAILED = '[Administration Consultant] Load Consultants Failed Action',

  LOAD_CONSULTANT_CLIENTS = '[Administration Consultant] Load Consultant Clients Action',
  LOAD_CONSULTANT_CLIENTS_SUCCESS = '[Administration Consultant] Load Consultant Clients Success Action',
  LOAD_CONSULTANT_CLIENTS_FAILED = '[Administration Consultant] Load Consultant Clients Failed Action',

  LOAD_CONSULTANT_MANAGERS = '[Administration Consultant] Load Consultant Managers Action',
  LOAD_CONSULTANT_MANAGERS_SUCCESS = '[Administration Consultant] Load Consultant Managers Success Action',
  LOAD_CONSULTANT_MANAGERS_FAILED = '[Administration Consultant] Load Consultant Managers Failed Action',

  UPDATE_CONSULTANT_MANAGER = '[Administration Consultant] Update Consultant Manager Action',
  UPDATE_CONSULTANT_MANAGER_SUCCESS = '[Administration Consultant] Update Consultant Manager Success Action',
  UPDATE_CONSULTANT_MANAGER_FAILED = '[Administration Consultant] Update Consultant Manager Failed Action',
  CONSULTANT_CSV_EXPORT = '[Administration Consultant] Consultant File Export Action',

  LOAD_LOG = '[Administration Log] Load Logs Action',
  LOAD_LOG_SUCCESS = '[Administration Log] Load Logs Success Action',
  LOAD_LOG_FAILED = '[Administration Log] Load Logs Failed Action',
  RESET_LOG_DATA = '[Administration Log] Reset Log Data Action',

  SET_LOG_SORT = '[Administration Log] Set Logs Sort',
  SET_LOG_PAGINATION = '[Administration Log] Set Logs Pagination',
  SET_LOG_FILTER = '[Administration Log] Set Logs Filter',

  EXPORT_LOGS = '[Administration Log] Export Logs Action',

  SET_DATA_COUNTRY = '[Administration Data Container] Set Data Country Action',

  LOAD_DATA_STATUS_DATA = '[Administration Data File Status] Load Data File Status Data Action',
  LOAD_DATA_STATUS_DATA_SUCCESS = '[Administration Data File Status] Load Data File Status Data Success Action',
  LOAD_DATA_STATUS_DATA_FAILED = '[Administration Data File Status] Load Data File Status Data Failed Action',

  DATA_STATUS_UPLOAD_FILES = '[Administration Data File Status] Data File Status Document Upload Action',
  DATA_STATUS_UPLOAD_FILES_SUCCESS = '[Administration Data File Status] Data File Status Document Upload Success Action',
  DATA_STATUS_UPLOAD_FILES_FAILED = '[Administration Data File Status] Data File Status Document Upload Failed Action',

  SET_DATA_STATUS_SORT = '[Administration Data File Status] Set Data File Status Sort Action',
  SET_DATA_STATUS_PAGINATION = '[Administration Data File Status] Set Data File Status Pagination Action',
  SET_DATA_STATUS_FILTER = '[Administration Data File Status] Set Data File Status Filter Action',

  DATA_STATUS_RESET = '[Administration Data File Status] Data File Status Reset Action',
  DATA_STATUS_REPORT = '[Administration Data File Status] Data File Status Report Action',
  DATA_STATUS_EXPORT = '[Administration Data File Status] Data File Status Export Action',
  DATA_STATUS_DOWNLOAD_DOCUMENT = '[Administration Data File Status] Data File Status Download Document Action',

  LOAD_DATA_OVERVIEW_DATA = '[Administration Data Overview] Load Overview Data Action',
  LOAD_DATA_OVERVIEW_DATA_SUCCESS = '[Administration Data Overview] Load Overview Data Success Action',
  LOAD_DATA_OVERVIEW_DATA_FAILED = '[Administration Data Overview] Load Overview Data Failed Action',
  RESET_DATA_OVERVIEW = '[Administration Data Overview] Load Overview Data Reset Action',

  SET_DATA_OVERVIEW_CLIENT = '[Administration Data Overview] Set Overview Client Filter Action',

  SET_DATA_OVERVIEW_ACCOUNT = '[Administration Data Overview] Set Overview Account Filter Action',

  LOAD_DATA_LOG = '[Administration Data Log] Load Data Log Action',
  LOAD_DATA_LOG_SUCCESS = '[Administration Data Log] Load Data Log Success Action',
  LOAD_DATA_LOG_FAILED = '[Administration Data Log] Load Data Log Failed Action',
  EXPORT_DATA_LOG = '[Administration Data Log] Export Data Log Action',
  EXPORT_DATA_LOG_FAILED = '[Administration Data Log] Export Data Log Failed Action',

  ROLLBACK_DATAFILE = '[Administration Data] Rollback Data File Action',
  ROLLBACK_DATAFILE_SUCCESS = '[Administration Data] Rollback Data File Success Action',
  ROLLBACK_DATAFILE_FAILED = '[Administration Data] Rollback Data File Failed Action',
  RESET_FILE_STATUS_DATA = '[Administration Data] Reset Data File Status Action',
  RESET_RECONCILIATION_DATA = '[Administration Data] Reset Reconciliation Data Action',
  LOAD_DOCUMENTS = '[Administration Document] Load Documents Action',
  LOAD_DOCUMENTS_SUCCESS = '[Administration Document] Load Documents Success Action',
  LOAD_DOCUMENTS_FAILED = '[Administration Document] Load Documents Failed Action',

  UPLOAD_DOCUMENTS = '[Administration Document] Upload Documents Action',
  UPLOAD_DOCUMENTS_SUCCESS = '[Administration Document] Upload Documents Success Action',
  UPLOAD_DOCUMENTS_FAILED = '[Administration Document] Upload Documents Failed Action',

  UPDATE_DOCUMENTS = '[Administration Document] Update Documents Action',
  UPDATE_DOCUMENTS_SUCCESS = '[Administration Document] Update Documents Success Action',
  UPDATE_DOCUMENTS_FAILED = '[Administration Document] Update Documents Failed Action',

  DELETE_DOCUMENTS = '[Administration Document] Delete Documents Action',
  DELETE_DOCUMENTS_SUCCESS = '[Administration Document] Delete Documents Success Action',
  DELETE_DOCUMENTS_FAILED = '[Administration Document] Delete Documents Failed Action',

  SET_DOCUMENT_SORT = '[Administration Document] Set Document Sort Action',
  SET_DOCUMENT_PAGINATION = '[Administration Document] Set Document Pagination Action',
  SET_DOCUMENT_FILTER = '[Administration Document] Set Document Filter Action',
  SET_DOCUMENT_RELOAD = '[Administration Document] Set Document Reload Trigger Action',
  DOWNLOAD_DOCUMENT_FILE = '[Administration Document] Download Document File Action',

  SAVE_NOTIFICATION_SETTINGS = '[Administration Notification] Save Notification Settings Action',
  SAVE_NOTIFICATION_SETTINGS_SUCCESS = '[Administration Notification] Save Notification Settings Success Action',
  SAVE_NOTIFICATION_SETTINGS_FAILED = '[Administration Notification] Save Notification Settings Failed Action',
  LOAD_NOTIFICATION_SETTINGS = '[Administration Notification] Load Notification Settings Action',
  LOAD_NOTIFICATION_SETTINGS_SUCCESS = '[Administration Notification] Load Notification Settings Success Action',
  LOAD_NOTIFICATION_SETTINGS_FAILED = '[Administration Notification] Load Notification Settings Failed Action',
  LOAD_LOG_NOTIFICATIONS = '[Administration Notification] Load Log Notification Action',
  LOAD_LOG_NOTIFICATIONS_SUCCESS = '[Administration Notification] Load Log Notification Success Action',
  LOAD_LOG_NOTIFICATIONS_FAILED = '[Administration Notification] Load Log Notification Failed Action',

  LOAD_REPORTS_DATES = '[Administration Reports] Load Reports Dates Action',
  LOAD_REPORTS_DATES_SUCCESS = '[Administration Reports] Load Reports Dates Success Action',
  LOAD_REPORTS_DATES_FAILED = '[Administration Reports] Load Reports Dates Failed Action',
  RESET_REPORTS_DATA = '[Administration Reports] Reset Reports Data Action',

  LOAD_FILTERED_STATIC_DATA = '[Administration Reports] Load Filtered Select Data Action',
  LOAD_FILTERED_STATIC_DATA_SUCCESS = '[Administration Reports] Load Filtered Select Data Success Action',
  LOAD_FILTERED_STATIC_DATA_FAILED = '[Administration Reports] Load Filtered Select Data Failed Action',

  SET_FILTERED_STATIC_DATA = '[Administration Reports] Set Filtered Static Data Action',
  SET_FILTERED_STATIC_DATA_SUCCESS = '[Administration Reports] Set Filtered Static Data Success Action',
  SET_FILTERED_STATIC_DATA_FAILED = '[Administration Reports] Set Filtered Static Data Failed Action',

  SET_STATIC_DATA_CONTENT_TYPE_FILTER = '[Administration Reports] Set Static Data Content Type Filter Action',
  SET_STATIC_DATA_COUNTRY_FILTER = '[Administration Reports] Set Static Data Country Filter Action',
  SET_STATIC_DATA_CLIENT_FILTER = '[Administration Reports] Set Static Data Client Filter Action',
  SET_STATIC_DATA_YEAR_FILTER = '[Administration Reports] Set Static Data Year Filter Action',
  SET_STATIC_DATA_MONTH_FILTER = '[Administration Reports] Set Static Data Month Filter Action',

  LOAD_REPORTS_DATES_BY_CLIENT = '[Administration Reports] Load Reports Dates By Client Action',
  LOAD_REPORTS_DATES_BY_CLIENT_SUCCESS = '[Administration Reports] Load Reports Dates By Client Success Action',
  LOAD_REPORTS_DATES_BY_CLIENT_FAILED = '[Administration Reports] Load Reports Dates By Client Failed Action',

  REMOVE_CLIENT_LOGO = '[Administration Clients] Remove Client Logo Action',
  REMOVE_CLIENT_LOGO_SUCCESS = '[Administration Clients] Remove Client Logo Success Action',
  REMOVE_CLIENT_LOGO_FAILED = '[Administration Clients] Remove Client Logo Failed Action',

  REMOVE_USER_PROFILE_IMAGE = '[Administration Users] Remove User Profile Image Action',
  REMOVE_USER_PROFILE_IMAGE_SUCCESS = '[Administration Users] Remove User Profile Image Success Action',
  REMOVE_USER_PROFILE_IMAGE_FAILED = '[Administration Users] Remove User Profile Image Failed Action',

  LOAD_RECONCILIATION_SUMMARY = '[Administration Data] Load Admin Data Reconciliation Action',
  LOAD_RECONCILIATION_SUMMARY_SUCCESS = '[Administration Data] Load Admin Data Reconciliation Success Action',
  LOAD_RECONCILIATION_SUMMARY_FAILED = '[Administration Data] Load Admin Data Reconciliation Failed Action',
  SET_DATA_RECONCILIATION_CLIENT = '[Administration Data] Load Admin Data Reconciliation Client Action',
  SET_DATA_RECONCILIATION_ACCOUNT = '[Administration Data] Load Admin Data Reconciliation Account Action',
  RESET_RECONCILIATION_SUMMARY = '[Administration Data] Reset Admin Data Reconciliation Action',

  REQUEST_RECONCILIATION_SUMMARY = '[Administration Data] Load Admin Data Reconciliation Action',
  REQUEST_RECONCILIATION_SUMMARY_SUCCESS = '[Administration Data] Load Admin Data Reconciliation Success Action',
  REQUEST_RECONCILIATION_SUMMARY_FAILED = '[Administration Data] Load Admin Data Reconciliation Failed Action',

  LOAD_RECONCILIATION_REQUEST = '[Administration Data] Load Admin Data Reconciliation Request Action',
  LOAD_RECONCILIATION_REQUEST_SUCCESS = '[Administration Data] Load Admin Data Reconciliation Request Success Action',
  LOAD_RECONCILIATION_REQUEST_FAILED = '[Administration Data] Load Admin Data Reconciliation Request Failed Action',

  SET_RECONCILIATION_SORT = '[Administration Data] Set Admin Data Reconciliation Request Sort Action',
  SET_RECONCILIATION_PAGINATION = '[Administration Data] Set Admin Data Reconciliation Request Pagination Action',
  RECONCILIATION_SUMMARY_DOWNLOAD = '[Administration Data] Download Admin Data Reconciliation Summary Action',

  DELETE_RECONCILIATION_REQUEST = '[Administration Data] Delete Admin Data Reconciliation Request Action',
  DELETE_RECONCILIATION_REQUEST_SUCCESS = '[Administration Data] Delete Admin Data Reconciliation Request Success Action',
  DELETE_RECONCILIATION_REQUEST_FAILED = '[Administration Data] Delete Admin Data Reconciliation Request Failed Action',

  CANCEL_RECONCILIATION_REQUEST = '[Administration Data] Cancel Admin Data Reconciliation Request Action',
  CANCEL_RECONCILIATION_REQUEST_SUCCESS = '[Administration Data] Cancel Admin Data Reconciliation Request Success Action',
  CANCEL_RECONCILIATION_REQUEST_FAILED = '[Administration Data] Cancel Admin Data Reconciliation Request Failed Action',

  CHECK_CLIENT_EXISTS = '[Administration Clients] Check Client Exists Action',
  CHECK_CLIENT_EXISTS_SUCCESS = '[Administration Clients] Check Client Exists Success Action',
  CHECK_CLIENT_EXISTS_FAILED = '[Administration Clients] Check Client Exists Failed Action',

  CHECK_USER_EXISTS = '[Administration Users] Check User Exists Action',
  CHECK_USER_EXISTS_SUCCESS = '[Administration Users] Check User Exists Success Action',
  CHECK_USER_EXISTS_FAILED = '[Administration Users] Check User Exists Failed Action',
  LOAD_RECIPIENT = '[Administration Data] Load Recipient Acion',
  LOAD_RECIPIENT_SUCCESS = '[Administration Data] Load Recipient Success Acion',
  LOAD_RECIPIENT_FAILED = '[Administration Data] Load Recipient Failed Acion',

  SAVE_ADMIN_NOTIFICATION_DETAILS = '[Administration Data] Save Admin Notification Details Acion',
  SAVE_ADMIN_NOTIFICATION_DETAILS_SUCCESS = '[Administration Data] Save Admin Notification Details Success Acion',
  SAVE_ADMIN_NOTIFICATION_DETAILS_FAILED = '[Administration Data] Save Admin Notification Details Failed Acion',


  LOAD_ADMIN_NOTIFICATION_DETAILS = '[Administration Data] Load Admin Notification Details Acion',
  LOAD_ADMIN_NOTIFICATION_DETAILS_SUCCESS = '[Administration Data] Load Admin Notification Details Success Acion',
  LOAD_ADMIN_NOTIFICATION_DETAILS_FAILED = '[Administration Data] Load Admin Notification Details Failed Acion',
  RESET_ADMIN_NOTIFICATION_DETAILS = '[Administration Data] Reset Admin Notification Details Acion'
}

/**
 * Account
 */
export class LoadAccountsAction implements Action {
  public readonly type = ActionTypes.LOAD_ACCOUNTS;
  public constructor(public payload: any) {
  }
}

export class LoadAccountsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_ACCOUNTS_SUCCESS;

  public constructor(public payload: Account[]) {
  }
}

export class LoadAccountsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_ACCOUNTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Fund
 */
export class LoadFundsAction implements Action {
  public readonly type = ActionTypes.LOAD_FUNDS;
  public constructor(public payload: any) { }
}

export class LoadFundsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_FUNDS_SUCCESS;

  public constructor(public payload: Fund[]) {
  }
}

export class LoadFundsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_FUNDS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Counts
 */
export class LoadCountsAction implements Action {
  public readonly type = ActionTypes.LOAD_COUNTS;
  public constructor(public payload: any) {
  }
}

export class LoadCountsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_COUNTS_SUCCESS;

  public constructor(public payload: ObjectCounts) {
  }
}

export class LoadCountsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_COUNTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Client Tab
 *
 * Load
 */
export class LoadClientsAction implements Action {
  public readonly type = ActionTypes.LOAD_CLIENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadClientsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_CLIENTS_SUCCESS;

  public constructor(public payload: LoadClientsResponse) {
  }
}

export class LoadClientsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_CLIENTS_FAILED;

  public constructor(public payload: any) {
  }
}

export class CheckClientExistsAction implements Action {
  public readonly type = ActionTypes.CHECK_CLIENT_EXISTS;
  public constructor(public payload: any) {
  }
}

export class CheckClientExistsSuccessAction implements Action {
  public readonly type = ActionTypes.CHECK_CLIENT_EXISTS_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class CheckClientExistsFailedAction implements Action {
  public readonly type = ActionTypes.CHECK_CLIENT_EXISTS_FAILED;
  public constructor(public payload: any) {
  }
}

export class CheckUserExistsAction implements Action {
  public readonly type = ActionTypes.CHECK_USER_EXISTS;
  public constructor(public payload: any) {
  }
}

export class CheckUserExistsSuccessAction implements Action {
  public readonly type = ActionTypes.CHECK_USER_EXISTS_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class CheckUserExistsFailedAction implements Action {
  public readonly type = ActionTypes.CHECK_USER_EXISTS_FAILED;
  public constructor(public payload: any) {
  }
}

/**
 * Create
 */
export class CreateClientAction implements Action {
  public readonly type = ActionTypes.CREATE_CLIENT;

  public constructor(public payload: Client) {
  }
}

export class CreateClientSuccessAction implements Action {
  public readonly type = ActionTypes.CREATE_CLIENT_SUCCESS;

  public constructor(public payload: Client) {
  }
}

export class CreateClientFailedAction implements Action {
  public readonly type = ActionTypes.CREATE_CLIENT_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Update
 */
export class UpdateClientAction implements Action {
  public readonly type = ActionTypes.UPDATE_CLIENT;

  public constructor(public payload: Client) {
  }
}

export class UpdateClientSuccessAction implements Action {
  public readonly type = ActionTypes.UPDATE_CLIENT_SUCCESS;

  public constructor(public payload: Client) {
  }
}

export class UpdateClientFailedAction implements Action {
  public readonly type = ActionTypes.UPDATE_CLIENT_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Sort, Pagination, Filter and PDF Export
 */
export class SetClientSortAction implements Action {
  public readonly type = ActionTypes.SET_CLIENT_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetClientPaginationAction implements Action {
  public readonly type = ActionTypes.SET_CLIENT_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class SetClientFilterAction implements Action {
  public readonly type = ActionTypes.SET_CLIENT_FILTER;

  public constructor(public payload: FilterInfo) {
  }
}

export class ClientPdfExportAction implements Action {
  public readonly type = ActionTypes.CLIENT_PDF_EXPORT;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

/**
 * User Tab
 *
 * Load
 */
export class LoadUsersAction implements Action {
  public readonly type = ActionTypes.LOAD_USERS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadUsersSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_USERS_SUCCESS;

  public constructor(public payload: LoadUsersResponse) {
  }
}

export class LoadUsersFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_USERS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Load User Clients
 */
export class LoadUserClientsAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_CLIENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadUserClientsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_CLIENTS_SUCCESS;

  public constructor(public payload: LoadClientsResponse) {
  }
}

export class LoadUserClientsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_USER_CLIENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Create
 */
export class CreateUserAction implements Action {
  public readonly type = ActionTypes.CREATE_USER;

  public constructor(public payload: User) {
  }
}

export class CreateUserSuccessAction implements Action {
  public readonly type = ActionTypes.CREATE_USER_SUCCESS;

  public constructor(public payload: User) {
  }
}

export class CreateUserFailedAction implements Action {
  public readonly type = ActionTypes.CREATE_USER_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Update
 */
export class UpdateUserAction implements Action {
  public readonly type = ActionTypes.UPDATE_USER;

  public constructor(public payload: User) {
  }
}

export class UpdateUserSuccessAction implements Action {
  public readonly type = ActionTypes.UPDATE_USER_SUCCESS;

  public constructor(public payload: User) {
  }
}

export class UpdateUserFailedAction implements Action {
  public readonly type = ActionTypes.UPDATE_USER_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Upload Profile Image
 */
export class UploadProfileImageAction implements Action {
  public readonly type = ActionTypes.UPLOAD_PROFILE_IMAGE;

  public constructor(public payload: any) {
  }
}

export class UploadProfileImageSuccessAction implements Action {
  public readonly type = ActionTypes.UPLOAD_PROFILE_IMAGE_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class UploadProfileImageFailedAction implements Action {
  public readonly type = ActionTypes.UPLOAD_PROFILE_IMAGE_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Upload Image
 */
export class UploadClientLogoAction implements Action {
  public readonly type = ActionTypes.UPLOAD_CLIENT_LOGO;

  public constructor(public payload: any) {
  }
}

export class UploadClientLogoSuccessAction implements Action {
  public readonly type = ActionTypes.UPLOAD_CLIENT_LOGO_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class UploadClientLogoFailedAction implements Action {
  public readonly type = ActionTypes.UPLOAD_CLIENT_LOGO_FAILED;

  public constructor(public payload: any) {
  }
}
/**
 * Sort, Paginate and PDF Export
 */
export class SetUserSortAction implements Action {
  public readonly type = ActionTypes.SET_USER_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetUserPaginationAction implements Action {
  public readonly type = ActionTypes.SET_USER_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class SetUserFilterAction implements Action {
  public readonly type = ActionTypes.SET_USER_FILTER;

  public constructor(public payload: FilterInfo) {
  }
}

export class UserPdfExportAction implements Action {
  public readonly type = ActionTypes.USER_PDF_EXPORT;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

/**
 * Consultant Tab
 *
 * Load
 */
export class LoadConsultantsAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANTS;
  public constructor(public payload: any) {
  }
}

export class LoadConsultantsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANTS_SUCCESS;

  public constructor(public payload: User[]) {
  }
}

export class LoadConsultantsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Load Consultant Clients
 */
export class LoadConsultantClientsAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_CLIENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}
export class LoadConsultantClientsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_CLIENTS_SUCCESS;

  public constructor(public payload: LoadClientsResponse) {
  }
}

export class LoadConsultantClientsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_CLIENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Load Consultant Managers
 */
export class LoadConsultantManagersAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_MANAGERS;
  public constructor(public payload: any) {
  }
}

export class LoadConsultantManagersSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_MANAGERS_SUCCESS;

  public constructor(public payload: Manager[]) {
  }
}

export class LoadConsultantManagersFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_CONSULTANT_MANAGERS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Update Consultant Managers
 */
export class UpdateConsultantManagerAction implements Action {
  public readonly type = ActionTypes.UPDATE_CONSULTANT_MANAGER;

  public constructor(public payload: ClientManagers) {
  }
}

export class UpdateConsultantManagerSuccessAction implements Action {
  public readonly type = ActionTypes.UPDATE_CONSULTANT_MANAGER_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class UpdateConsultantManagerFailedAction implements Action {
  public readonly type = ActionTypes.UPDATE_CONSULTANT_MANAGER_FAILED;

  public constructor(public payload: any) {
  }
}

export class ConsultantCSVExportAction implements Action {
  public readonly type = ActionTypes.CONSULTANT_CSV_EXPORT;

  public constructor(public payload: LoadDataRequest) {
  }
}

/**
 * Log Tab
 *
 * Load Data
 */
export class LoadLogsAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadLogsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG_SUCCESS;

  public constructor(public payload: LogsResponse) {
  }
}

export class LoadLogsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG_FAILED;

  public constructor(public payload: any) {
  }
}

export class ResetLogDataAction implements Action {
  public readonly type = ActionTypes.RESET_LOG_DATA;
}
/**
 * Sort, Pagination, Filters
 */
export class SetLogsPaginationAction implements Action {
  readonly type = ActionTypes.SET_LOG_PAGINATION;

  // public constructor(public payload: PaginationInfo) {
  // }
  public constructor(public payload: PaginationInfo) {
  }
}

export class SetLogsSortAction implements Action {
  public readonly type = ActionTypes.SET_LOG_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetLogFilterAction implements Action {
  public readonly type = ActionTypes.SET_LOG_FILTER;

  public constructor(public payload: { from: string; to: string; filter: FilterInfo }) {
  }
}



/**
 * Export Logs PDF
 */
export class ExportLogsAction implements Action {
  public readonly type = ActionTypes.EXPORT_LOGS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

/**
 * Data Tab
 */
export class SetDataCountryAction implements Action {
  public readonly type = ActionTypes.SET_DATA_COUNTRY;

  public constructor(public payload: string) {
  }
}

/**
 * File Status
 *
 * Load Data
 */
export class LoadDataFileStatusDataAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_STATUS_DATA;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadDataFileStatusDataSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_STATUS_DATA_SUCCESS;

  public constructor(public payload: LoadFileResponse) {
  }
}

export class LoadDataFileStatusDataFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_STATUS_DATA_FAILED;

  public constructor(public payload: any) {
  }
}

export class ResetFileStatusDataAction implements Action {
  public readonly type = ActionTypes.RESET_FILE_STATUS_DATA;
}

export class ResetReconciliationDataAction implements Action {
  public readonly type = ActionTypes.RESET_RECONCILIATION_DATA;
}
/**
 * Upload Document Files
 */
export class DataFileStatusUploadDocumentsAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_UPLOAD_FILES;

  public constructor(public payload: UploadFileRequest) {
  }
}

export class DataFileStatusUploadDocumentsSuccessAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_UPLOAD_FILES_SUCCESS;
}

export class DataFileStatusUploadDocumentsFailedAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_UPLOAD_FILES_FAILED;
}

/**
 * Sort, Pagination, Filter, Export, Download File
 */
export class SetDataFileStatusSortAction implements Action {
  public readonly type = ActionTypes.SET_DATA_STATUS_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetDataFileStatusPaginationAction implements Action {
  public readonly type = ActionTypes.SET_DATA_STATUS_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class SetReconciliationSortAction implements Action {
  public readonly type = ActionTypes.SET_RECONCILIATION_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetReconciliationPaginationAction implements Action {
  public readonly type = ActionTypes.SET_RECONCILIATION_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}
export class SetDataFileStatusFilterAction implements Action {
  public readonly type = ActionTypes.SET_DATA_STATUS_FILTER;

  public constructor(public payload: { from: string; to: string; filter: FilterInfo }) {
  }
}

export class DataFileStatusResetAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_RESET;
}

export class DataFileStatusReportAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_REPORT;
}

/**
 * Unfinished feature, waiting for changes
 */
export class DataFileStatusExportAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_EXPORT;

  public constructor(public payload: any) {
  }
}

export class DataFileStatusDownloadDocumentAction implements Action {
  public readonly type = ActionTypes.DATA_STATUS_DOWNLOAD_DOCUMENT;

  public constructor(public payload: { _id: string; filename: string }) {
  }
}

/**
 * Overview
 *
 * Load Data
 */
export class LoadDataOverviewDataAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_OVERVIEW_DATA;

  public constructor(public payload: LoadRequest) {
  }
}

export class ResetDataOverviewAction implements Action {
  readonly type = ActionTypes.RESET_DATA_OVERVIEW;
}

export class LoadDataOverviewDataSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_OVERVIEW_DATA_SUCCESS;

  public constructor(public payload: OverviewItem[]) {
  }
}

export class LoadDataOverviewDataFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_OVERVIEW_DATA_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Data Log
 *
 * Load Data Log
 */
export class LoadDataLogAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_LOG;

  public constructor(public payload: LoadDataRequest) {
  }
}

export class LoadDataLogSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_LOG_SUCCESS;

  public constructor(public payload: LoadFileResponse) {
  }
}

export class LoadDataLogFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_DATA_LOG_FAILED;

  public constructor(public payload: any) {
  }
}

export class ExportDataLogAction implements Action {
  public readonly type = ActionTypes.EXPORT_DATA_LOG;

  public constructor(public payload: any) {
  }
}

export class ExportDataLogFailedAction implements Action {
  public readonly type = ActionTypes.EXPORT_DATA_LOG_FAILED;

  public constructor(public payload: any) {
  }
}

export class RollbackDataFileAction implements Action {
  public readonly type = ActionTypes.ROLLBACK_DATAFILE;

  public constructor(public payload: any) {
  }
}

export class RollbackDataFileSuccessAction implements Action {
  public readonly type = ActionTypes.ROLLBACK_DATAFILE_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class RollbackDataFileFailedAction implements Action {
  public readonly type = ActionTypes.ROLLBACK_DATAFILE_FAILED;
  public constructor(public payload: any) {
  }
}

/**
 * Set Client Filter
 */
export class SetDataOverviewClientAction implements Action {
  public readonly type = ActionTypes.SET_DATA_OVERVIEW_CLIENT;

  public constructor(public payload: Client[]) {
  }
}

/**
 * Set Account Filter
 */
export class SetDataOverviewAccountAction implements Action {
  public readonly type = ActionTypes.SET_DATA_OVERVIEW_ACCOUNT;

  public constructor(public payload: Account[]) {
  }
}

/**
 * Document Tab
 *
 * Load
 */
export class LoadDocumentsAction implements Action {
  public readonly type = ActionTypes.LOAD_DOCUMENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadDocumentsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_DOCUMENTS_SUCCESS;

  public constructor(public payload: LoadDocumentsResponse) {
  }
}

export class LoadDocumentsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Upload
 */
export class UploadDocumentsAction implements Action {
  public readonly type = ActionTypes.UPLOAD_DOCUMENTS;

  public constructor(public payload: FormData) {
  }
}

export class UploadDocumentsSuccessAction implements Action {
  public readonly type = ActionTypes.UPLOAD_DOCUMENTS_SUCCESS;

  public constructor(public payload: string[]) {
  }
}

export class UploadDocumentsFailedAction implements Action {
  public readonly type = ActionTypes.UPLOAD_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Update
 */
export class UpdateDocumentsAction implements Action {
  public readonly type = ActionTypes.UPDATE_DOCUMENTS;

  public constructor(public payload: Document) {
  }
}

export class UpdateDocumentsSuccessAction implements Action {
  public readonly type = ActionTypes.UPDATE_DOCUMENTS_SUCCESS;

  public constructor(public payload: Document) {
  }
}

export class UpdateDocumentsFailedAction implements Action {
  public readonly type = ActionTypes.UPDATE_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Delete
 */
export class DeleteDocumentsAction implements Action {
  public readonly type = ActionTypes.DELETE_DOCUMENTS;

  public constructor(public payload: string) {
  }
}

export class DeleteDocumentsSuccessAction implements Action {
  public readonly type = ActionTypes.DELETE_DOCUMENTS_SUCCESS;

  public constructor(public payload: string) {
  }
}

export class DeleteDocumentsFailedAction implements Action {
  public readonly type = ActionTypes.DELETE_DOCUMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Sort, Pagination, Filter, Download File
 */
export class SetDocumentSortAction implements Action {
  public readonly type = ActionTypes.SET_DOCUMENT_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetDocumentPaginationAction implements Action {
  public readonly type = ActionTypes.SET_DOCUMENT_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class SetDocumentFilterAction implements Action {
  public readonly type = ActionTypes.SET_DOCUMENT_FILTER;

  public constructor(public payload: FilterInfo) {
  }
}

export class DownloadDocumentFileAction implements Action {
  public readonly type = ActionTypes.DOWNLOAD_DOCUMENT_FILE;

  public constructor(public payload: { _id: string; filename: string }) {
  }
}

/**
 * Reload Trigger
 *
 * This thing is a workaround to prevent reloading data after each successful update
 */
export class SetDocumentReloadTriggerAction implements Action {
  public readonly type = ActionTypes.SET_DOCUMENT_RELOAD;

  public constructor(public payload: number) {
  }
}

export class SaveNotificationSettingsAction implements Action {
  public readonly type = ActionTypes.SAVE_NOTIFICATION_SETTINGS;
  public constructor(public payload: any) { }
}

export class SaveNotificationSettingsSuccessAction implements Action {
  public readonly type = ActionTypes.SAVE_NOTIFICATION_SETTINGS_SUCCESS;
  public constructor(public payload: any) { }
}

export class SaveNotificationSettingsFailedAction implements Action {
  public readonly type = ActionTypes.SAVE_NOTIFICATION_SETTINGS_FAILED;
  public constructor(public payload: any) { }
}

export class LoadNotificationSettingsAction implements Action {
  public readonly type = ActionTypes.LOAD_NOTIFICATION_SETTINGS;
  public constructor(public payload: any) { }
}

export class LoadNotificationSettingsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_NOTIFICATION_SETTINGS_SUCCESS;
  public constructor(public payload: any) { }
}

export class LoadNotificationSettingsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_NOTIFICATION_SETTINGS_FAILED;
  public constructor(public payload: any) { }
}

export class LoadLogNotificationsAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG_NOTIFICATIONS;
}

export class LoadLogNotificationsSuccessAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG_NOTIFICATIONS_SUCCESS;
  public constructor(public payload: any) { }
}

export class LoadLogNotificationsFailedAction implements Action {
  public readonly type = ActionTypes.LOAD_LOG_NOTIFICATIONS_FAILED;
  public constructor(public payload: any) { }
}

export class LoadReportsDatesAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadReportsDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadReportsDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class ResetReportsDataAction implements Action {
  readonly type = ActionTypes.RESET_REPORTS_DATA;
}

export class SetStaticContentTypeFilterAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_CONTENT_TYPE_FILTER;

  public constructor(public payload: string) {
  }
}

export class SetStaticContentCountryFilterAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_COUNTRY_FILTER;


  public constructor(public payload: string) {
  }
}

export class SetStaticContentClientFilterAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_CLIENT_FILTER;


  public constructor(public payload: string) {
  }
}

export class SetStaticContentYearFilterAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_YEAR_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetStaticContentMonthFilterAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_MONTH_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetFilteredStaticDataAction implements Action {
  readonly type = ActionTypes.SET_FILTERED_STATIC_DATA;

  public constructor(public payload: StaticDataPayload[]) {
  }
}

export class SetFilteredStaticDataSuccessAction implements Action {
  readonly type = ActionTypes.SET_FILTERED_STATIC_DATA_SUCCESS;

  public constructor(public payload: StaticDataPayload[]) {
  }
}

export class SetFilteredStaticDataFailedAction implements Action {
  readonly type = ActionTypes.SET_FILTERED_STATIC_DATA_FAILED;
}

export class LoadFilteredStaticDataAction implements Action {
  readonly type = ActionTypes.LOAD_FILTERED_STATIC_DATA;

  public constructor(public payload: any) {
  }
}

export class LoadFilteredStaticDataSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_FILTERED_STATIC_DATA_SUCCESS;

  public constructor(public payload: StaticData) {
  }
}

export class LoadFilteredStaticDataFailedAction implements Action {
  readonly type = ActionTypes.LOAD_FILTERED_STATIC_DATA_FAILED;

}

export class LoadReportsDatesByClientAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_BY_CLIENT;

  public constructor(public payload: any) {
  }
}

export class LoadReportsDatesByClientSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_BY_CLIENT_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class LoadReportsDatesByClientFailedAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_BY_CLIENT_FAILED;

  public constructor(public payload: any) {
  }
}

export class RemoveClientLogoAction implements Action {
  readonly type = ActionTypes.REMOVE_CLIENT_LOGO;

  public constructor(public payload: any) {
  }
}

export class RemoveClientLogoSuccessAction implements Action {
  readonly type = ActionTypes.REMOVE_CLIENT_LOGO_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class RemoveClientLogoFailedAction implements Action {
  readonly type = ActionTypes.REMOVE_CLIENT_LOGO_FAILED;

  public constructor(public payload: any) {
  }
}

export class RemoveUserProfileImageAction implements Action {
  readonly type = ActionTypes.REMOVE_USER_PROFILE_IMAGE;

  public constructor(public payload: any) {
  }
}

export class RemoveUserProfileImageSuccessAction implements Action {
  readonly type = ActionTypes.REMOVE_USER_PROFILE_IMAGE_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class RemoveUserProfileImageFailedAction implements Action {
  readonly type = ActionTypes.REMOVE_USER_PROFILE_IMAGE_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadReconciliationRequestAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_REQUEST;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadReconciliationRequestSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_REQUEST_SUCCESS;
  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadReconciliationRequestFailedAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_REQUEST_FAILED;
  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class RequestReconciliationSummaryAction implements Action {
  readonly type = ActionTypes.REQUEST_RECONCILIATION_SUMMARY;

  public constructor(public payload: any) {
  }
}

export class RequestReconciliationSummarySuccessAction implements Action {
  readonly type = ActionTypes.REQUEST_RECONCILIATION_SUMMARY_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class RequestReconciliationSummaryFailedAction implements Action {
  readonly type = ActionTypes.REQUEST_RECONCILIATION_SUMMARY_FAILED;

  public constructor(public payload: any) {
  }
}


export class LoadReconciliationSummaryAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_SUMMARY;

  public constructor(public payload: any) {
  }
}

export class LoadReconciliationSummarySuccessAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_SUMMARY_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class LoadReconciliationSummaryFailedAction implements Action {
  readonly type = ActionTypes.LOAD_RECONCILIATION_SUMMARY_FAILED;

  public constructor(public payload: any) {
  }
}

export class CancelReconciliationRequestAction implements Action {
  readonly type = ActionTypes.CANCEL_RECONCILIATION_REQUEST;

  public constructor(public payload: any) {
  }
}

export class CancelReconciliationRequestSuccessAction implements Action {
  readonly type = ActionTypes.CANCEL_RECONCILIATION_REQUEST_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class CancelReconciliationRequestFailedAction implements Action {
  readonly type = ActionTypes.CANCEL_RECONCILIATION_REQUEST_FAILED;

  public constructor(public payload: any) {
  }
}


export class DeleteReconciliationRequestAction implements Action {
  readonly type = ActionTypes.DELETE_RECONCILIATION_REQUEST;

  public constructor(public payload: any) {
  }
}

export class DeleteReconciliationRequestSuccessAction implements Action {
  readonly type = ActionTypes.DELETE_RECONCILIATION_REQUEST_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class DeleteReconciliationRequestFailedAction implements Action {
  readonly type = ActionTypes.DELETE_RECONCILIATION_REQUEST_FAILED;

  public constructor(public payload: any) {
  }
}

export class ReconciliatonSummaryDownloadAction implements Action {
  public readonly type = ActionTypes.RECONCILIATION_SUMMARY_DOWNLOAD;

  public constructor(public payload: { requestId: string; name: string; type: string }) {

  }
}



/**
 * Set Account Filter
 */
export class SetReconciliationSummaryAction implements Action {
  public readonly type = ActionTypes.SET_DATA_RECONCILIATION_ACCOUNT;
  public constructor(public payload: Account[]) {

  }
}

export class ResetReconciliationSummaryAction implements Action {
  public readonly type = ActionTypes.RESET_RECONCILIATION_SUMMARY;
}


export class LoadRecipientAction implements Action {
  readonly type = ActionTypes.LOAD_RECIPIENT;
  public constructor(public payload: any) {
  }
}

export class LoadRecipientSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_RECIPIENT_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class LoadRecipientFailedAction implements Action {
  readonly type = ActionTypes.LOAD_RECIPIENT_FAILED;
  public constructor(public payload: any) {
  }
}


export class SaveAdminNotificationDetailsAction implements Action {
  readonly type = ActionTypes.SAVE_ADMIN_NOTIFICATION_DETAILS;
  public constructor(public payload: any) {
  }
}

export class SaveAdminNotificationDetailsSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_ADMIN_NOTIFICATION_DETAILS_SUCCESS;
  public constructor(public payload: any) {
  }
}

export class SaveAdminNotificationDetailsFailedAction implements Action {
  readonly type = ActionTypes.SAVE_ADMIN_NOTIFICATION_DETAILS_FAILED;
  public constructor(public payload: any) {
  }
}

export class LoadAdminNotificationDetailsAction implements Action {
  readonly type = ActionTypes.LOAD_ADMIN_NOTIFICATION_DETAILS;
  public constructor(public payload: any) {
  }
}

export class LoadAdminNotificationDetailsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_ADMIN_NOTIFICATION_DETAILS_SUCCESS;
  public constructor(public payload: any) {

  }
}

export class LoadAdminNotificationDetailsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_ADMIN_NOTIFICATION_DETAILS_FAILED;
  public constructor(public payload: any) {
  }
}

export class ResetAdminNotificationDetailsAction implements Action {
  public readonly type = ActionTypes.RESET_ADMIN_NOTIFICATION_DETAILS;
}
export type Actions =
  /**
   * Account
   */
  LoadAccountsAction |
  LoadAccountsSuccessAction |
  LoadAccountsFailedAction |
  /**
   * Fund
   */
  LoadFundsAction |
  LoadFundsSuccessAction |
  LoadFundsFailedAction |
  /**
   * Counts
   */
  LoadCountsAction |
  LoadCountsSuccessAction |
  LoadCountsFailedAction |
  /**
   * Client Tab
   *
   * Load
   */
  LoadClientsAction |
  LoadClientsSuccessAction |
  LoadClientsFailedAction |
  /**
   * Create
   */
  CreateClientAction |
  CreateClientSuccessAction |
  CreateClientFailedAction |
  /**
   * Update
   */
  UpdateClientAction |
  UpdateClientSuccessAction |
  UpdateClientFailedAction |
  /**
   * Client Sort, Paginate, Filter, PDF Export
   */
  SetClientSortAction |
  SetClientPaginationAction |
  SetClientFilterAction |
  ClientPdfExportAction |
  /**
   * User Tab
   *
   * Load
   */
  LoadUsersAction |
  LoadUsersSuccessAction |
  LoadUsersFailedAction |
  /**
   * Load User Clients
   */
  LoadUserClientsAction |
  LoadUserClientsSuccessAction |
  LoadUserClientsFailedAction |
  /**
   * Create
   */
  CreateUserAction |
  CreateUserSuccessAction |
  CreateUserFailedAction |
  /**
   * Update
   */
  UpdateUserAction |
  UpdateUserSuccessAction |
  UpdateUserFailedAction |
  /**
   * User Sort, Paginate, PDF Export
   */
  SetUserSortAction |
  SetUserPaginationAction |
  SetUserFilterAction |
  UserPdfExportAction |
  /**
   * Consultant Tab
   *
   * Load
   */
  LoadConsultantsAction |
  LoadConsultantsSuccessAction |
  LoadConsultantsFailedAction |
  /**
   * Load Consultant Clients
   */
  LoadConsultantClientsAction |
  LoadConsultantClientsSuccessAction |
  LoadConsultantClientsFailedAction |
  /**
   * Load Consultant Managers
   */
  LoadConsultantManagersAction |
  LoadConsultantManagersSuccessAction |
  LoadConsultantManagersFailedAction |
  /**
   * Update Consultant Managers
   */
  UpdateConsultantManagerAction |
  UpdateConsultantManagerSuccessAction |
  UpdateConsultantManagerFailedAction |

  /**
 * User Sort, Paginate, PDF Export
 */
  SetUserSortAction |
  SetUserPaginationAction |
  SetUserFilterAction |
  ConsultantCSVExportAction |
  /**
/**
 * Log Tab
 *
 * Load Data
 */
  LoadLogsAction |
  LoadLogsSuccessAction |
  LoadLogsFailedAction |
  ResetLogDataAction |
  /**
   * Sort, Pagination, Filters, Export PDF
   */
  SetLogsSortAction |
  SetLogsPaginationAction |
  SetLogFilterAction |
  ExportLogsAction |
  /**
   * Data Tab
   */
  SetDataCountryAction |
  /**
   * File Status
   *
   * Load Data
   */
  LoadDataFileStatusDataAction |
  LoadDataFileStatusDataSuccessAction |
  LoadDataFileStatusDataFailedAction |
  ResetFileStatusDataAction |
  /**
   * Upload Document
   */
  DataFileStatusUploadDocumentsAction |
  DataFileStatusUploadDocumentsSuccessAction |
  DataFileStatusUploadDocumentsFailedAction |
  /**
   * Sort, Pagination, Filter, Reset, Report, Export, Download Document
   */
  SetDataFileStatusSortAction |
  SetDataFileStatusPaginationAction |
  SetDataFileStatusFilterAction |
  DataFileStatusResetAction |
  DataFileStatusReportAction |
  DataFileStatusExportAction |
  DataFileStatusDownloadDocumentAction |

  /**
   * Data - Data Log
   */
  LoadDataLogAction |
  LoadDataLogSuccessAction |
  LoadDataLogFailedAction |

  /**
   * Overview
   *
   * Load Data
   */
  LoadDataOverviewDataAction |
  LoadDataOverviewDataSuccessAction |
  LoadDataOverviewDataFailedAction |
  ResetDataOverviewAction |

  RollbackDataFileAction |
  RollbackDataFileSuccessAction |
  RollbackDataFileFailedAction |
  /**
   * Set Client Filter
   */
  SetDataOverviewClientAction |
  /**
   * Set Account Filter
   */
  SetDataOverviewAccountAction |
  /**
   * Document Tab
   *
   * Load
   */
  LoadDocumentsAction |
  LoadDocumentsSuccessAction |
  LoadDocumentsFailedAction |
  /**
   * Upload
   */
  UploadDocumentsAction |
  UploadDocumentsSuccessAction |
  UploadDocumentsFailedAction |
  /**
   * Update
   */
  UpdateDocumentsAction |
  UpdateDocumentsSuccessAction |
  UpdateDocumentsFailedAction |
  /**
   * Delete
   */
  DeleteDocumentsAction |
  DeleteDocumentsSuccessAction |
  DeleteDocumentsFailedAction |
  /**
   * Document Sort, Paginate, Filter, Download File
   */
  SetDocumentSortAction |
  SetDocumentPaginationAction |
  SetDocumentFilterAction |
  SetDocumentReloadTriggerAction |
  DownloadDocumentFileAction |

  /**
   * Notification
   *
   * Load and save actions
   */
  SaveNotificationSettingsAction |
  SaveNotificationSettingsSuccessAction |
  SaveNotificationSettingsFailedAction |
  LoadNotificationSettingsAction |
  LoadNotificationSettingsSuccessAction |
  LoadNotificationSettingsFailedAction |
  LoadLogNotificationsAction |
  LoadLogNotificationsSuccessAction |
  LoadLogNotificationsFailedAction |
  UploadProfileImageAction |
  UploadProfileImageSuccessAction |
  UploadProfileImageFailedAction |
  UploadClientLogoAction |
  UploadClientLogoSuccessAction |
  UploadClientLogoFailedAction |

  /**
   * Reports
   *
   * Load actions
   */
  LoadFilteredStaticDataAction |
  LoadFilteredStaticDataSuccessAction |
  LoadFilteredStaticDataFailedAction |
  SetFilteredStaticDataAction |
  SetFilteredStaticDataSuccessAction |
  SetFilteredStaticDataFailedAction |
  SetStaticContentTypeFilterAction |
  SetStaticContentCountryFilterAction |
  SetStaticContentClientFilterAction |
  SetStaticContentYearFilterAction |
  SetStaticContentMonthFilterAction |
  LoadReportsDatesAction |
  LoadReportsDatesSuccessAction |
  LoadReportsDatesFailedAction |
  ResetReportsDataAction |
  LoadReportsDatesByClientAction |
  LoadReportsDatesByClientSuccessAction |
  LoadReportsDatesByClientFailedAction |
  RemoveClientLogoAction |
  RemoveClientLogoSuccessAction |
  RemoveClientLogoFailedAction |
  RemoveUserProfileImageAction |
  RemoveUserProfileImageSuccessAction |
  RemoveUserProfileImageFailedAction |
  /**
   * Reconciliation
   *
   * Load, save, download and delete actions
   */
  LoadReconciliationSummaryAction |
  LoadReconciliationSummarySuccessAction |
  LoadReconciliationSummaryFailedAction |
  SetReconciliationSummaryAction |
  ResetReconciliationSummaryAction |
  RequestReconciliationSummaryAction |
  RequestReconciliationSummaryFailedAction |
  RequestReconciliationSummarySuccessAction |
  LoadReconciliationRequestAction |
  LoadReconciliationRequestSuccessAction |
  LoadReconciliationRequestFailedAction |
  SetReconciliationSortAction |
  SetReconciliationPaginationAction |
  ReconciliatonSummaryDownloadAction |
  ResetReconciliationDataAction |
  DeleteReconciliationRequestAction |
  DeleteReconciliationRequestSuccessAction |
  DeleteReconciliationRequestFailedAction |
  CancelReconciliationRequestAction |
  CancelReconciliationRequestSuccessAction |
  CancelReconciliationRequestFailedAction |
  CheckClientExistsAction |
  CheckClientExistsSuccessAction |
  CheckClientExistsFailedAction |
  CheckUserExistsAction |
  CheckUserExistsSuccessAction |
  CheckUserExistsFailedAction |
  LoadRecipientAction |
  LoadRecipientSuccessAction |
  LoadRecipientFailedAction |
  SaveNotificationSettingsAction |
  SaveNotificationSettingsSuccessAction |
  SaveNotificationSettingsFailedAction |
  LoadAdminNotificationDetailsAction |
  LoadAdminNotificationDetailsSuccessAction |
  LoadAdminNotificationDetailsFailedAction |
  ResetAdminNotificationDetailsAction;
